import { Store } from '@ngrx/store';
import { IController } from 'angular';
import * as _ from 'lodash';
import { RegentsSubject } from '../../../../../ng2/shared/constants/regents.constant';
import { ChangeMadeInMetrics, ChangeSavedInMetrics } from '../../../../../ng2/store/actions/metrics-actions';

export class RegentsMetricsTableCtrl implements IController {
  static $inject: string[] = ['Store'];

  // bindings
  private changeMadeInMetrics: { status: boolean };
  private regentsTableCopy: Array<{ [key: string]: boolean }>;
  public cohort: Array<{ [key: string]: boolean }>;

  constructor(private store: Store<any>) {}

  public getRegentsSubjects() {
    let regentsSubjectsAsCollection = _.values(RegentsSubject);
    let regentsSubjectsSorted = regentsSubjectsAsCollection.sort(function(a, b) {
      return a.order - b.order;
    });
    return regentsSubjectsSorted;
  }

  public getTermIndexes(): number[] {
    let ret = [];
    for (let i = 0; i < this.cohort.length; i++) {
      ret.push(i);
    }
    return ret;
  }

  public updateTableRow(classKey, termIndex, change): Array<{ [key: string]: boolean }> {
    let modifiedCellValue = change;

    // FOR TRUE
    if (modifiedCellValue === true) {
      for (let i = termIndex + 1; i < this.cohort.length; i++) {
        this.cohort[i][classKey] = change;
      }
    }

    // FOR FALSE
    if (modifiedCellValue === false) {
      for (let j = termIndex - 1; j >= 0; j--) {
        this.cohort[j][classKey] = change;
      }
    }
    this.changeMadeInMetrics.status = !_.isEqual(this.cohort, this.regentsTableCopy) ? true : false;

    if (this.changeMadeInMetrics.status) {
      this.store.dispatch(new ChangeMadeInMetrics());
    } else {
      this.store.dispatch(new ChangeSavedInMetrics());
    }
    return this.cohort;
  }
}

angular.module('nv.SchoolMetricsModule').controller('RegentsMetricsTableCtrl', RegentsMetricsTableCtrl);
